import { render, staticRenderFns } from "./DiseaseSystems.vue?vue&type=template&id=44a43d90&scoped=true"
import script from "./DiseaseSystems.vue?vue&type=script&lang=js"
export * from "./DiseaseSystems.vue?vue&type=script&lang=js"
import style0 from "./DiseaseSystems.vue?vue&type=style&index=0&id=44a43d90&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a43d90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44a43d90')) {
      api.createRecord('44a43d90', component.options)
    } else {
      api.reload('44a43d90', component.options)
    }
    module.hot.accept("./DiseaseSystems.vue?vue&type=template&id=44a43d90&scoped=true", function () {
      api.rerender('44a43d90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DiseaseSystems.vue"
export default component.exports